import BriefEditor from "@/views/Order/widgets/BriefEditor.vue";
import PayEditor from "@/views/Order/widgets/PayEditor.vue";
import CancelEditor from "@/views/Order/widgets/CancelEditor.vue";
import { RenderOrderLists } from "@/mixinsApp/Render.js";
import PayEditorBatch from "@/views/Order/widgets/PayEditorBatch.vue";

export default {
	components: { BriefEditor, PayEditor, CancelEditor, PayEditorBatch },

	data() {
		return {
			isInfoPage: false,
			cancelEditorVisible: "",
			cancelEditorId: "",
			briefEditorId: "",
			briefEditorVisible: false,
			payEditorId: "",
			payEditorVisible: false,

			payIsIncome: true,
			itemTableFields: [
				{
					name: "product_color",
					isOnlyShow: true,
				},
				{
					name: "color_code",
					isOnlyShow: true,
				},
				{
					name: "color_name",
					isOnlyShow: true,
				},
				{
					name: "model",
					isOnlyShow: true,
				},
				{
					name: "price_per",
				},
				{
					name: "amount",
				},
				{
					name: "total_price",
					isOnlyShow: true,
				},
			],
			sumFields: [
				{
					name: "count",
					title: "数量(笔)",
				},
				{
					name: "sum_total_price",
					title: "总价",
				},
			],
		};
	},
	methods: {
		refreshInfoData() {
			this.loadings.main = true;
			this.$axios
				.post(`/curd/edit/order/${this.recordId}`)
				.then(json => {
					// this.info = Object.assign({}, json.data.info);
					json.data.info.forEach((v, k) => {
						this.$set(this.info, k, v);
					});
					if (this.$refs["baseInfoTable"]) {
						this.$nextTick(() => {
							this.$refs["baseInfoTable"].setData(json.data.info);
						});
					}

					this.loadings.main = false;
					this.hasGetData = true;
				})
				.catch(json => {
					console.error(json);
					this.loadings.main = false;
				});
		},
		goOrderInfo(id, json) {
			if (this.$route.name == "Order-Info") {
				//已经在 info，刷新页面
				this.info = Object.assign({}, json.data.info);
				this.$nextTick(() => {
					this.$refs["baseInfoTable"].setData(json.data.info);
				});
			} else {
				const { href } = this.$router.resolve({
					name: "Order-Info",
					params: {
						id: id,
						tab: "info",
					},
				});
				window.open(href, "_blank");
			}
		},
		goInfo(id, json) {
			if (this.$route.name == "Order-Info") {
				//已经在 info，刷新页面
				this.info = Object.assign({}, json.data.info);
				this.$nextTick(() => {
					this.$refs["baseInfoTable"].setData(json.data.info);
				});
			} else {
				const { href } = this.$router.resolve({
					name: "Order-Info",
					params: {
						id: id,
						tab: "info",
					},
				});
				window.open(href, "_blank");
			}
		},
		goOrderEditCancel(id) {
			this.cancelEditorId = id;
			this.cancelEditorVisible = true;
		},
		goOrderEditBrief(id) {
			this.briefEditorId = id;
			this.briefEditorVisible = true;
		},
		goOrderEdit(id) {
			if (this.$route.name == "Order-Info") {
				this.$router.push({
					name: "Order-Info",
					params: {
						id: id,
						tab: "edit",
					},
				});
			} else {
				const { href } = this.$router.resolve({
					name: "Order-Info",
					params: {
						id: id,
						tab: "edit",
					},
				});
				window.open(href, "_blank");
			}
		},
		// goSendTx(id) {
		// 	this.$router.push({
		// 		name: "Order-Send",
		// 		params: {
		// 			id: id
		// 		}
		// 	});
		// },
		goCheckTx(id) {
			if (this.$route.name == "Order-Info") {
				this.$router.push({
					name: "Order-Info",
					params: {
						id: id,
						tab: "tx",
					},
				});
			} else {
				const { href } = this.$router.resolve({
					name: "Order-Info",
					params: {
						id: id,
						tab: "tx",
					},
				});
				window.open(href, "_blank");
			}
		},
		doRecvTx(id) {
			this.$confirm("确认已经收到款项, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$axios
						.post(`/inventory/do_tx_op/recv/${id}`)
						.then(json => {
							this.$message.success("成功");
							this.goInfo(id, json);
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		goRevertChange(id) {
			this.$router.push({
				name: "Order-Info",
				params: {
					id: id,
					tab: "revert",
				},
			});
		},

		doDeleteOrder(id) {
			this.$confirm("删除订单将无法恢复数据，确认继续？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/orderm/do_order_delete/${id}`;

					this.loadings.main = true;
					this.$axios
						.post(url, {})
						.then(json => {
							this.loadings.main = false;
							if (this.$route.name == "Order-Info") {
								this.$router.push({
									name: "Order-Index",
								});
							} else {
								this.refreshTable("listTable");
							}
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		doRevertConfirm(id) {
			this.$confirm("确认后商品将直接入库，确定已经收到货物？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/orderm/do_revert_confirm/${id}`;

					this.loadings.main = true;
					this.$axios
						.post(url, {})
						.then(json => {
							this.loadings.main = false;
							this.$router.push({
								name: "Order-Info",
								params: {
									id: json.data.info._id,
									tab: "info",
								},
							});
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		doRejectOrder(id) {
			this.$confirm("取消出库状态，重新修改订单？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/orderm/do_order_reject/${id}`;

					this.loadings.main = true;
					this.$axios
						.post(url, {})
						.then(json => {
							this.loadings.main = false;
							this.$router.push({
								name: "Order-Info",
								params: {
									id: json.data.info._id,
									tab: "tx",
								},
							});
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		doHasPayed(id) {
			this.payIsIncome = true;
			this.payEditorId = id;
			this.payEditorVisible = true;
		},
		doHasReceive(id) {
			this.$axios
				.post(`/orderm/do_has_receive/${id}`, {})
				.then(json => {
					this.loadings.main = false;
					this.$message.success("成功");
					this.refreshData();
				})
				.catch(json => {
					this.loadings.main = false;
					this.$message.error(json.data.msg);
				});
		},
		doHasReturnPayed(id) {
			this.payIsIncome = false;
			this.payEditorId = id;
			this.payEditorVisible = true;
		},
		doCancelPayed(id) {
			this.$confirm("取消付款状态继续编辑", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				this.$axios
					.post(`/orderm/do_cancel_payed/${id}`, {})
					.then(json => {
						this.loadings.main = false;
						this.$message.success("成功");
						this.refreshData();
					})
					.catch(json => {
						this.loadings.main = false;
						this.$message.error(json.data.msg);
					});
			});
		},
		doRejectTx(id) {
			this.$confirm("取消出库状态，重新修改订单？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/orderm/do_reject_order/${id}`;

					this.loadings.main = true;
					this.$axios
						.post(url, {})
						.then(json => {
							this.loadings.main = false;
							this.$router.push({
								name: "Order-Info",
								params: {
									id: json.data.info._id,
									tab: "tx",
								},
							});
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消",
					});
				});
		},
		doPrint() {
			window.print();
		},
		handleBatch_doHasPayed(checks) {
			//批量处理付款
			this.batchConfirmInfo = {
				count: 0,
				info: {
					total_price: 0,
					pay_method: {
						index: 30,
						name: "挂帐/月结",
					},
					payed_at: 0,
					desc: "",
					primary_img: "",
				},
				recordIds: [],
				checked: {
					total_price: false,
					pay_method: false,
					payed_at: false,
					desc: false,
					primary_img: false,
				},
			};
			const data = this.$refs["orderListTable"].tableData.filter((v, k) => {
				return checks[k];
			});
			data.forEach(v => {
				this.batchConfirmInfo.count++;
				this.batchConfirmInfo.info.total_price += v.total_price;
				this.batchConfirmInfo.info.pay_method = v.pay_method;
				this.batchConfirmInfo.info.payed_at = v.payed_at;
				this.batchConfirmInfo.info.desc = "";
				this.batchConfirmInfo.info.primary_img = v.primary_img;
				this.batchConfirmInfo.recordIds.push(v._id);
			});
			this.editorBatchVisible = true;
		},
	},
};
